<template>
    <div class="actions">
        <a v-if="canPurchase" class="lib-button full-width" href="javascript:void(0)" @click="$emit('purchase')">Subscribe Now</a>
        <a v-else href="/contact-us">Contact Us</a>
    </div>
</template>

<script>
export default {
    name: 'ActionsWidget',
    props: ['canPurchase'],
};
</script>

<style scoped lang="scss">
@import "../../scss/prelude";

.actions {
    text-align: center;
    margin-bottom: 8px;
}
</style>